import { render, staticRenderFns } from "./700_KSAT25-30-0700-video-Social_Engineering_Red_Flags.vue?vue&type=template&id=76344ce3&lang=pug"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports